import styled, { css } from 'styled-components';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

export const Box = styled.div``;

export const DesktopMegamenu = styled.div`
  opacity: 0.1;
  animation: submenu 1s forwards;
  @keyframes submenu {
    0% {
      opacity: 0.1;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const CollectionLink = styled(LinkWithLocale)`
  width: 100%;
  cursor: pointer;
  &:hover {
    img {
      -ms-transform: scale(1.3);
      -webkit-transform: scale(1.3);
      transform: scale(1.3);
    }
    p {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
  img {
    transform: scale(1.2);
    transition: transform 500ms ease-in-out;
  }
  p {
    transition: color 500ms ease-in-out;
  }
`;

export const CollectionItem = styled.div`
  text-align: center;
  margin-bottom: 8px;
`;

export const CollectionTitle = styled.p`
  text-wrap: wrap;
  font-size: 14px;
  font-weight: 400;
`;

export const IMG = styled.img`
  margin-bottom: 24px;
  width: 100%;
`;

export const Collections = styled.div`
  display: flex;
  padding: 16px 44px 24px 44px;
  a {
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
    transition: color 0.2s;
    white-space: nowrap;
    font-style: normal;
    line-height: 20px;
    ${({
      theme: {
        colors: { primaryBlue },
        fontFamilies,
      },
    }) => css`
      color: ${primaryBlue};
      font-family: ${fontFamilies.openSans};
    `}
  }
`;

export const LinkBox = styled.div`
  margin-bottom: 40px;
  text-align: center;
  & > a {
    text-decoration: none;
    text-transform: uppercase;
    font-size: 14px;

    ${({
      theme: {
        colors: { primary, primaryBlue },
        fontFamilies: { openSans },
        fontWeights: { bold },
      },
    }) => css`
      font-weight: ${bold};
      font-family: ${openSans};
      color: ${primaryBlue};
      padding-bottom: 5px;
      border-bottom: 2px solid ${primary};
      &:hover {
        border-bottom: 2px solid ${primaryBlue};
      }
      transition: color 800ms ease-in-out, border-bottom 800ms ease-in-out;
    `}
  }
`;
